import type { DirectorReviewSummary } from "./narrationDirectorReview";

export function NarrationDirectorReviews({
  reviews,
}: {
  reviews: DirectorReviewSummary[];
}) {
  return (
    <div className="space-y-2 border-b pb-3">
      {reviews.map((review, index) => (
        <div key={`${review.scope}-${review.inputDigest}-${index}`}>
          <p>
            <strong>
              {review.scope === "editorial"
                ? "Editorial review"
                : "Measured sequence review"}
              :
            </strong>{" "}
            {review.status.replaceAll("_", " ")} · {review.mode}
            {review.route ? ` · ${review.route}` : ""}
          </p>
          {review.findings.map((finding) => (
            <p key={finding.id}>
              {finding.severity}: {finding.explanation} {finding.change}
            </p>
          ))}
          {review.inputDigest && (
            <p className="text-muted-foreground">
              Input {review.inputDigest.slice(0, 12)}
            </p>
          )}
        </div>
      ))}
      <p className="text-muted-foreground">
        These reviews evaluate story and measured timing. Audible delivery needs
        a listening review.
      </p>
    </div>
  );
}
